import { render, staticRenderFns } from "./tSaleNew.vue?vue&type=template&id=15f746c5&scoped=true"
import script from "./tSaleNew.vue?vue&type=script&lang=js"
export * from "./tSaleNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f746c5",
  null
  
)

export default component.exports